module.exports = __webpack_public_path__ + "img/hzms_card.3b83d445.png";